<template>
	<div class="row">
		<div class="small-12 medium-8 medium-offset-2">
			<div v-if="youtubeUrl && canShowVideo" class="flex-video">
				<iframe 
					:src="youtubeUrl" 
					width="560" 
					height="315" 
					frameborder="0" 
					allowfullscreen></iframe>
			</div>

			<cookie-consent-fallback-message 
				v-if="!canShowVideo"
				:type="'video'" 
				:externalSite="'YouTube'" 
				:externalUrl="data.src" />

		</div>
	</div>
</template>


<script>
import { ConsentVideo } from 'DcVueCookiebot/mixins/ConsentVideo.js'
export default {
	props: ['data'],
	mixins: [ConsentVideo],
	computed: {
		youtubeUrl() {
			return (typeof this.data.src !== 'undefined') ? this.data.src.replace('watch?v=', 'embed/').replace('youtube.com', 'youtube-nocookie.com') : false;
		}
	},
	components: {
		CookieConsentFallbackMessage: () => import('DcVueCookiebot/components/global/CookieConsentFallbackMessage'),
	},
}
</script>